import {
	SET_SITES_FROM_SERVER,
	SET_BROWSER_DATA,
	CHANGE_BROWSER_DATA_WHEN_DELETE,
	CHANGE_BROWSER_DATA_WHEN_ADD,
	CHANFE_BROWSER_DATA_WHEN_RENAME,
	SET_FILE_CONTENT
} from '../constants';

const setSitesFromServer = (data) => {
	return {
		type: SET_SITES_FROM_SERVER,
		payload: data
	};
};

const setBrowserData = (data) => {
	return {
		type: SET_BROWSER_DATA,
		payload: data
	};
};

const setChangedBrowserDataWhenDelete = (data) => {
	return {
		type: CHANGE_BROWSER_DATA_WHEN_DELETE,
		payload: data
	};
};

const setChangedBrowserDataWhenAdd = (data) => {
	return {
		type: CHANGE_BROWSER_DATA_WHEN_ADD,
		payload: data
	};
};

const setChangedBrowserDataWhenRename = (data) => {
	return {
		type: CHANFE_BROWSER_DATA_WHEN_RENAME,
		payload: data
	};
};

const setFileContent = (data) => {
	return {
		type: SET_FILE_CONTENT,
		payload: data
	};
};

export {
	setSitesFromServer,
	setBrowserData,
	setChangedBrowserDataWhenDelete,
	setChangedBrowserDataWhenAdd,
	setChangedBrowserDataWhenRename,
	setFileContent
};
